export const MAX_IMG_COUNT = 9;
